import { createSelector } from 'reselect';
import { selectors as usageSelectors } from '@saucelabs/sl-module-usage';

import billingReducer from '../../reducers';
import { changedOrderItemsSelector, purchaseContainerSelector } from '../purchase/selectors';
import { getNonLegacyPlans } from '../plans/selectors';
import { currentMonthlyRateSelector, getSubscriptionsSelector } from '../subscriptions/selectors';
import { paymentFormSelector } from '../billing-info/selectors';

type BillingAppState = ReturnType<typeof billingReducer>
const getStore = (state) => state.apps.billing as BillingAppState;

const checkoutSelector = createSelector(
  getStore,
  purchaseContainerSelector,
  getNonLegacyPlans,
  currentMonthlyRateSelector,
  getSubscriptionsSelector,
  changedOrderItemsSelector,
  paymentFormSelector,
  usageSelectors.availableCreditsSelector,
  (
    billingState,
    purchaseContainer,
    nonLegacyPlans,
    currentMonthlyRate,
    currentSubscriptions,
    orderItems,
    paymentForm,
    availableCredits,
  ) => ({
    ...purchaseContainer,
    allPlans: nonLegacyPlans,
    checkoutPreview: billingState.checkout.get('checkoutPreview'),
    couponCode: billingState.checkout.get('couponCode'),
    currentMonthlyRate,
    currentSubscriptions,
    isPreviewLoaded: billingState.checkout.get('isPreviewLoaded'),
    orderItems,
    paymentForm,
    totalAvailableCredits: availableCredits.totalAvailableCredits,
  }),
);

export {
  checkoutSelector,
};
